export const REFURBISH_DEVICE_OPEN_MODAL = "REFURBISH_DEVICE_OPEN_MODAL";
export const REFURBISH_DEVICE_CLOSE_MODAL = "REFURBISH_DEVICE_CLOSE_MODAL";

export const REFURBISH_DEVICE_REQUEST = "REFURBISH_DEVICE_REQUEST";
export const REFURBISH_DEVICE_RESULT = "REFURBISH_DEVICE_RESULT";